import { Controller } from "@hotwired/stimulus"

/**
 * Feature Toggle Controller
 * 
 * Handles show/hide behavior for feature content based on checkbox state.
 * 
 * Usage:
 *   <div data-controller="feature-toggle">
 *     <input type="checkbox" data-feature-toggle-target="checkbox" data-action="change->feature-toggle#toggle">
 *     <div data-feature-toggle-target="content">Content to show/hide</div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["checkbox", "content"]

  connect() {
    // Set initial visibility based on checkbox state
    this.updateVisibility()
  }

  toggle() {
    this.updateVisibility()
  }

  updateVisibility() {
    const isChecked = this.checkboxTarget.checked
    const isDisabled = this.checkboxTarget.disabled
    
    this.contentTargets.forEach(content => {
      // Always show content if checkbox is disabled
      if (isDisabled) {
        content.style.display = 'block'
        return
      }
      
      if (isChecked) {
        // Use slideDown animation if jQuery is available
        if (window.$ && $.fn.slideDown) {
          $(content).slideDown(200)
        } else {
          content.style.display = 'block'
        }
      } else {
        // Use slideUp animation if jQuery is available
        if (window.$ && $.fn.slideUp) {
          $(content).slideUp(200)
        } else {
          content.style.display = 'none'
        }
      }
    })
  }
}
